define('flight-components/GoogleWallet',['require','flight/lib/component','jquery','gapi'],function(require){

  // Dependencies
  var component   = require('flight/lib/component'),
      $           = require('jquery');
      gapi        = require('gapi');

  return component(GoogleWallet);
  
  // Constructor
  function GoogleWallet() {

    this.defaultAttrs({
      buttonWrapperSelector: '.js-google-wallet'
    });

    this.googleWalletSuccessHandler = function(args) {
      var self = this;
      var btnData = self.attr.buttonData;
      
      self.trigger(document, 'ui-track-event', {name: 'savedToGoogleWallet'});

/*      $.ajax({
        url: VPAPP.context + '/updatewalletobject',
        data: {
          'componentUID': btnData.uid,
          'redemptionCode': btnData.redemptionCode,
          'googleWalletObjecIdToUpdate': btnData.walletObjId
        },
        success: function(response) {
          // manually trigger DTM rule
          self.trigger(document, 'ui-track-event', {name: 'savedToGoogleWallet'});
        }
      });*/
    }

    this.googleWalletFailureHandler = function(args) {
      console.error('Failed to render Google Wallet button', args);
    }

    this.after('initialize', function() {
      var self = this;

      self.attr.buttonData = self.$node.data();

      window.googleWalletSuccessHandler = function(args) {
        self.googleWalletSuccessHandler(args)
      }
      window.googleWalletFailureHandler = function(args) {
        self.googleWalletFailureHandler(args);  
      };

      gapi.savetowallet.render('google-wallet-button-container',{
        "jwt": self.attr.buttonData.jwt,
        "onsuccess": "googleWalletSuccessHandler",
        "onfailure": "googleWalletFailureHandler",
        "theme":"gray",
        "text":"long",
        "height":"standard",
        "size":"matchparent"
      });
    });

  };

});
